export default {
  title: 'Footer'
}

const Template = args => `
  <cradlepoint-footer
    json="${args.json}"
    logo="${args.logo}"
  ></cradlepoint-footer>
`;

export const Default = Template.bind({});

Default.args = {
  json: 'https://corsproxy.io/?https%3A%2F%2Fcradlepoint.com%2Fwp-content%2Fuploads%2Fcradlepoint-posts-json%2Fpost-15867.json',
  logo: 'https://img.cradlepoint.com/auto-mapping-folder/2022/04/cradlepoint-ericsson-logo-footer-378x70-1.png'
}
